import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'omalon';
const args = {};

export class Omalon extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
